import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "Athlynx — Sports Management Platform";
const TITLES = [
  ["/dashboard", "Dashboard | Athlynx"],
  ["/pipeline", "Pipeline | Athlynx"],
  ["/players", "Athletes | Athlynx"],
  ["/clubs", "Clubs | Athlynx"],
  ["/calendar", "Calendar | Athlynx"],
  ["/relances", "Follow-ups | Athlynx"],
  ["/discussions", "Discussions | Athlynx"],
  ["/performance/contracts", "Contract Performance | Athlynx"],
  ["/performance", "Performance | Athlynx"],
  ["/contracts", "Contracts | Athlynx"],
  ["/documents", "Documents | Athlynx"],
  ["/import", "Import | Athlynx"],
  ["/settings", "Settings | Athlynx"],
  ["/billing", "Billing | Athlynx"],
  ["/login", "Login | Athlynx"],
  ["/register", "Sign up | Athlynx"],
];

export default function TitleManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const match = TITLES.find(([p]) => pathname === p || pathname.startsWith(`${p}/`));
    document.title = match ? match[1] : DEFAULT_TITLE;
  }, [pathname]);
  return null;
}
